import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
    dialogContent: {
        flex: "1",
        // padding: "20px 10px 10px",
        backgroundColor: "#FFFFFF",
        minWidth: "850px"
    },
    dialogPaper: {
        minWidth: "800px",
        maxWidth: '880px'
    },
    box: {
        display: "flex",
        flexFlow: "column",
        height: "100%",
        // padding: "18px 10px 10px 20px",
        padding: '0px 0px 15px 0px'
    },
    header: {
        flex: "0 1 auto",
        display: "flex",
        padding: '15px 10px',
        alignItems: 'baseline',
        cursor: 'move',
        backgroundColor: "#454545",
        justifyContent: 'space-between'
    },
    content: {
        flex: "1 1 auto",
        // maxHeight: "580px",
        // overflow: "auto",
        marginBottom: "10px",
        padding: '10px 20px'
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        justifyContent: 'space-between',
        borderBottom: '1px solid #F1F1F1',
        backgroundColor: "#DFEEFF",
        padding: '0 10px'
    },
    shippingLayout: {
        "& .custom-label": {
            // marginTop: '10px !important',
        }

    },
    marginTopTwenty: {
        marginTop: '25px',
    },
    cardHeaderTitle: {
        display: "flex",
        alignItems: "center"
    },
    container: {
        paddingRight: '25px'
    },
    footer: {
        flex: "0 1 40px",
        gap: '10px',
        padding: '0 20px'
    },
    footerRight: {
        float: "right",
        marginRight: "-8px",
        display: 'flex',
        gap: '10px'
    },
    notesEditor: {
        "& .RichTextEditor__root___2QXK-": {
            minHeight: '160px',
            maxHeight: '160px',
            overflow: 'auto',
        }
    },
    crossButton: {
        position: "relative",
        top: "-12px",
        right: "10px",
        cursor: "pointer",
        padding: "3px",
        zIndex: "2",
        display: "block",
        "& :hover": {
            backgroundColor: "#F4F4F4",
        }
    },
    closeIcon: {
        cursor: 'pointer',
        color: 'white',
    },
    title: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        color: '#FFFFFF',
        letterSpacing: '0.02em',
    },
    labelText: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '20px',
        color: '#3C4549',
        padding: "14px 0px 5px",
    },
    valueText: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '20px',
        color: '#454545',
        padding: "6px 0",
        textTransform: 'capitalize',
    },
    backBtn: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 600,
        color: '454545',
        borderRadius: '4px',
        padding: '8px 16px',
        textTransform: 'capitalize',
        border: '1px solid #454545',
    },
    changeBtn: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 600,
        cursor: 'pointer',
        backgroundColor: '#454545',
        borderRadius: '4px',
        marginRight: '5px',
        padding: '8px 16px',
        textTransform: 'capitalize',
        cursor: 'pointer',
        color: '#ffffff',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: 'rgba(71, 71, 71, 1)',
        }
    },
    secHeading: {
        color: '#4F4F4F',
        fontSize: '16px',
        lineHeight: '12px',
        padding: '12px 6px',
        borderBottom: '1px solid #BBBEBF',
        width: '100%',
        marginBottom: '15px',
        fontFamily: 'Lato',
        fontWeight: 600,
    },
    selectBaseInput: {
        border: '1px solid #a0a4a6',
        borderRadius: '5px',
        background: 'white',
        marginRight: '7px',
        width: '100%',
        "& select": {
            padding: '8px 10px',
            margin: 0,
            fontSize: '14px',

        }
    },
    positionRelative: {
        position: 'relative',

        "& button": {
            position: 'absolute',
            top: '4px',
            right: '5px'
        }
    },
    chipGap: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '5px'
    },
    hr: {
        opacity: '0.4'
    },
    joditParent: {
        marginBottom: '10px'


    },
    imageBox: {
        "& .custom-input": {
            padding: '5px',
            height: 'unset'
        }
    },

    richTextEditor: {
        "& .public-DraftEditor-content": {
            minHeight: '150px',
            fontFamily: 'Lato'
        }
    },
    dragFile: {
        margin: '0px 0px',
        textAlign: 'center',
        border: '2px dotted #cccccc',
        padding: '8px',
        borderRadius: '10px',
        minHeight: '210px',
        cursor: 'pointer',
        justifyContent: 'center',
        flexFlow: 'column',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        "& img": {
            margin: '0px 0',
            objectFit: 'cover',
            borderRadius: '10px',
        }
    },
    RemoveImage: {
        background: 'black',
        color: 'white',
        fontSize: '16px',
        display: 'flex',
        width: '24px',
        height: '24px',
        justifyContent: 'center',
        borderRadius: '50px',
        position: 'absolute',
        right: '-6px',
        top: '-11px',
        cursor: 'pointer',
        lineHeight: '1.3',

    },
}));